import { setSession } from './utils';
import { JWT_STORAGE_KEY, USER_STORAGE_KEY, REFRESH_STORAGE_KEY } from './constant';

type AuthRefValue = {
  clearAuth: (() => void) | null;
};

export const authRef: AuthRefValue = { clearAuth: null };

export function fallbackClearAuth(): void {
  localStorage.removeItem(JWT_STORAGE_KEY);
  localStorage.removeItem(REFRESH_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);
  setSession(null);
}

export function clearAuthFromOutside(): void {
  if (authRef.clearAuth) {
    authRef.clearAuth();
  } else {
    fallbackClearAuth();
  }
}
